export const SIGN_UP_URL = 'https://forms.gle/zxQDRkgkwRqo1mbT9';
